export default "__VITE_ASSET__5b470dee__"